import "../App.css";
import { useState, useEffect } from "react";

function PackageDetail({ setShowPackages, packageData }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = {
    app: {
      fontFamily: '"Space Grotesk", sans-serif',
      lineHeight: 1.6,
      backgroundColor: "#0a0b0e",
      color: "#ffffff",
      position: "relative",
      overflowX: "hidden",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      paddingBottom: "200px",
    },
    backButton: {
      position: "fixed",
      top: "1.2rem",
      left: "2rem",
      padding: "0.75rem 1.5rem",
      fontSize: "1rem",
      background: "rgba(88, 101, 242, 0.1)",
      border: "1px solid rgba(88, 101, 242, 0.5)",
      borderRadius: "8px",
      color: "#ffffff",
      cursor: "pointer",
      transition: "all 0.3s ease",
      zIndex: 1001,
      fontFamily: '"Space Grotesk", sans-serif',
      letterSpacing: "1px",
      backdropFilter: "blur(8px)",
    },
    backArrow: {
      marginRight: "0.5rem",
    },
    packagesHeader: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      height: "80px",
      background: "rgba(20, 23, 31, 0.95)",
      backdropFilter: "blur(8px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderBottom: "1px solid rgba(88, 101, 242, 0.2)",
      zIndex: 1000,
      padding: "0 2rem",
    },
    headerContent: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    },
    titlePart: {
      fontSize: "2.5rem",
      fontWeight: 800,
      color: "#ffffff",
      textShadow: "0 0 20px rgba(88, 101, 242, 0.5)",
      letterSpacing: "2px",
      textTransform: "uppercase",
      background: "linear-gradient(45deg, #fff, #5865f2)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    hero: {
      flex: 1,
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      background: "linear-gradient(135deg, rgba(88, 101, 242, 0.1) 0%, rgba(10, 11, 14, 0.9) 100%)",
      paddingTop: isMobile ? "1rem" : "80px",
    },
    packageDetail: {
      maxWidth: "1000px",
      margin: isMobile ? "1rem" : "7rem auto",
      padding: isMobile ? "1rem" : "2rem",
      background: "rgba(20, 23, 31, 0.7)",
      backdropFilter: "blur(10px)",
      border: "1px solid rgba(88, 101, 242, 0.2)",
      borderRadius: "16px",
      width: isMobile ? "95%" : "auto",
    },
    packageTitle: {
      fontSize: isMobile ? "1.8rem" : "2.5rem",
      marginBottom: isMobile ? "1rem" : "1.5rem",
      textAlign: "center",
      color: "#ffffff",
    },
    packageDetailPrice: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "center",
      alignItems: "center",
      gap: isMobile ? "1rem" : "4rem",
      marginBottom: isMobile ? "1.5rem" : "2rem",
      padding: isMobile ? "1rem" : "1.5rem",
      background: "rgba(20, 23, 31, 0.95)",
      borderRadius: "12px",
      border: "1px solid rgba(88, 101, 242, 0.2)",
    },
    priceSpan: {
      display: "inline-flex",
      alignItems: "center",
      fontSize: isMobile ? "1.3rem" : "1.5rem",
      fontWeight: 600,
      color: "#ffffff",
      fontFamily: '"Space Grotesk", sans-serif',
      position: "relative",
      padding: "0 1rem",
    },
    packageDetailContent: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
      gap: isMobile ? "1.5rem" : "2rem",
      marginBottom: isMobile ? "1.5rem" : "2rem",
      width: "100%",
    },
    detailSection: {
      background: "rgba(88, 101, 242, 0.1)",
      padding: isMobile ? "1rem" : "1.5rem",
      borderRadius: "12px",
      border: "1px solid rgba(88, 101, 242, 0.2)",
    },
    sectionTitle: {
      color: "#5865f2",
      marginBottom: isMobile ? "0.8rem" : "1rem",
      fontSize: isMobile ? "1.3rem" : "1.5rem",
      fontWeight: "bold",
    },
    servicesList: {
      listStyle: "none",
      marginLeft: 0,
      padding: 0,
    },
    serviceItem: {
      padding: isMobile ? "0.4rem 0" : "0.5rem 0",
      fontSize: isMobile ? "1rem" : "1.1rem",
      display: "flex",
      alignItems: "center",
      "&::before": {
        content: '"⬢"',
        color: "#5865f2",
        marginRight: "0.5rem",
      },
    },
    scheduleButton: {
      display: "block",
      width: "fit-content",
      margin: isMobile ? "1.5rem auto 0" : "2rem auto 0",
      padding: isMobile ? "0.8rem 1.5rem" : "1rem 2rem",
      fontSize: isMobile ? "1.1rem" : "1.2rem",
      background: "rgba(88, 101, 242, 0.2)",
      border: "1px solid rgba(88, 101, 242, 0.5)",
      borderRadius: "8px",
      color: "#ffffff",
      textDecoration: "none",
      transition: "all 0.3s ease",
      textTransform: "uppercase",
      letterSpacing: "1px",
      textAlign: "center",
      "&:hover": {
        background: "rgba(88, 101, 242, 0.3)",
        transform: "translateY(-2px)",
        boxShadow: "0 5px 15px rgba(88, 101, 242, 0.2)",
      },
    },
    mobileHeader: {
      background: "rgba(20, 23, 31, 0.95)",
      backdropFilter: "blur(8px)",
      borderBottom: "1px solid rgba(88, 101, 242, 0.2)",
      padding: "0.5rem",
      width: "100%",
    },
    mobileHeaderContent: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "0.4rem",
      padding: "0.5rem",
    },
    mobileTitlePart: {
      fontSize: "1.8rem",
      fontWeight: 800,
      color: "#ffffff",
      textShadow: "0 0 20px rgba(88, 101, 242, 0.5)",
      letterSpacing: "2px",
      textTransform: "uppercase",
      background: "linear-gradient(45deg, #fff, #5865f2)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      textAlign: "center",
      lineHeight: 1.2,
    },
    mobileBackButton: {
      padding: "0.4rem",
      fontSize: "1.2rem",
      background: "rgba(88, 101, 242, 0.2)",
      border: "1px solid rgba(88, 101, 242, 0.5)",
      borderRadius: "8px",
      color: "#ffffff",
      cursor: "pointer",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "35px",
      height: "35px",
      marginTop: "-5px",
      lineHeight: 1,
    },
    mobileSocialIcons: {
      display: "flex",
      gap: "1rem",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "0.3rem",
    },
    footerContainer: {
      borderTop: "1px solid rgba(88, 101, 242, 0.2)",
      background: "rgba(20, 23, 31, 0.9)",
    },
    contactSection: {
      textAlign: "center",
      padding: "1.5rem 1rem 0.5rem",
      position: "relative",
      zIndex: 1,
    },
    contactTitle: {
      fontSize: "1.5rem",
      color: "#ffffff",
      marginBottom: "1rem",
      textShadow: "0 0 10px rgba(88, 101, 242, 0.3)",
    },
    contactInfo: {
      display: "flex",
      flexDirection: "column",
      gap: "0.5rem",
      alignItems: "center",
      justifyContent: "center",
    },
    contactItem: {
      display: "flex",
      alignItems: "center",
      gap: "0.5rem",
      fontSize: "1rem",
      color: "#ffffff",
      textDecoration: "none",
      padding: "0.35rem 0.75rem",
      background: "rgba(88, 101, 242, 0.1)",
      borderRadius: "8px",
      border: "1px solid rgba(88, 101, 242, 0.2)",
      transition: "all 0.3s ease",
    },
    icon: {
      fontSize: "1.2rem",
    },
    footer: {
      width: "100%",
      textAlign: "center",
      padding: "1rem",
      color: "#8e9aff",
    },
    contactUs: {
      textAlign: "center",
      marginTop: "1rem",
      padding: "1rem",
      background: "rgba(88, 101, 242, 0.1)",
      borderRadius: "8px",
    },
  };

  // Determine package type
  const isInteriorPackage = packageData.title === "The Interior Package";
  const isExteriorPackage = packageData.title === "The Exterior Package";
  const isBasicPackage = packageData.title === "The Basic Package";
  const isMaintenancePackage = packageData.title === "Maintenance Customers";

  // Split services for Deluxe and Basic packages
  const interiorServices = isInteriorPackage ? packageData.services : isExteriorPackage ? [] : isBasicPackage ? packageData.services.slice(0, 6) : isMaintenancePackage ? packageData.services.slice(0, 1) : packageData.services.slice(0, 9);

  const exteriorServices = isInteriorPackage ? [] : isExteriorPackage ? packageData.services : isBasicPackage ? packageData.services.slice(6) : isMaintenancePackage ? packageData.services.slice(1) : packageData.services.slice(9);

  // Add MobileHeader component
  const MobileHeader = ({ setShowPackages }) => (
    <header style={styles.mobileHeader}>
      <div style={styles.mobileHeaderContent}>
        <div style={styles.mobileTitlePart}>BROT AUTO DETAILING</div>
        <div style={styles.mobileSocialIcons}>
          <button style={styles.mobileBackButton} onClick={() => setShowPackages("packages")}>
            ←
          </button>
        </div>
      </div>
    </header>
  );

  return (
    <div style={styles.app}>
      {/* Only show desktop back button in desktop mode */}
      {!isMobile && (
        <button style={styles.backButton} onClick={() => setShowPackages("packages")}>
          <span style={styles.backArrow}>←</span>
          <span>Back</span>
      </button>
      )}

      {/* Conditional rendering of header based on screen size */}
      {isMobile ? (
        <MobileHeader setShowPackages={setShowPackages} />
      ) : (
        <header style={styles.packagesHeader}>
          <div style={styles.headerContent}>
            <span style={styles.titlePart}>BROT AUTO DETAILING</span>
        </div>
      </header>
      )}

      <section style={styles.hero}>
        <div style={styles.packageDetail}>
          <h1 style={styles.packageTitle}>{packageData.title}</h1>
          <div style={styles.packageDetailPrice}>
            <span style={styles.priceSpan}>
              <span>{packageData.price}</span>
            </span>
            <span style={styles.priceSpan}>{packageData.duration}</span>
          </div>

          <div style={styles.packageDetailContent}>
            <div style={styles.detailSection}>
              <h2 style={styles.sectionTitle}>
                {isMaintenancePackage ? "How It Works?" : "Interior Services Included"}
              </h2>
              <ul style={styles.servicesList}>
                {interiorServices.map((service, index) => (
                  <li key={index} style={styles.serviceItem}>
                    {typeof service === "string" ? service : service.name}
                  </li>
                ))}
              </ul>
            </div>
            <div style={styles.detailSection}>
              <h2 style={styles.sectionTitle}>
                {isMaintenancePackage ? "Contact Us!" : "Exterior Services Included"}
              </h2>
              <ul style={styles.servicesList}>
                {exteriorServices.map((service, index) => {
                  // Get the service name
                  const serviceName = typeof service === "string" ? service : service.name;

                  // Check if the current package is the Deluxe Package
                  if (packageData.title === "The Deluxe Package") {
                    // Bold and underline specific items
                    if (service.isHeader || 
                        serviceName === "Apply Shine on Rubber Mats" || 
                        serviceName === "Custom Carpet Designs" || 
                        serviceName === "Remove any Sticker or Tape Residue" || 
                        serviceName === "1 Month Ceramic Wax (Protection, Hydrophobic Effects, and Shine)") {
                      return (
                        <li key={index} style={styles.serviceItem}>
                          <strong><u>{serviceName}</u></strong>
                        </li>
                      );
                    }
                  }
                  return (
                    <li key={index} style={styles.serviceItem}>
                      {serviceName}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          <a href={packageData.calendarLink} style={styles.scheduleButton} target="_blank" rel="noopener noreferrer">
            {isMobile ? "Schedule Now" : "Schedule an Appointment"}
          </a>

          {isMobile && (
            <div style={styles.contactUs}>
              <h2 style={styles.contactTitle}>OR CONTACT US</h2>
              <p style={styles.contactInfo}>
                <a href="tel:+16504544583" style={styles.contactItem}>
                  <span style={styles.icon}>📞</span>
                  (650) 454-4583
                </a>
                <a href="mailto:brotdetailing@gmail.com" style={styles.contactItem}>
                  <span style={styles.icon}>📧</span>
                  brotdetailing@gmail.com
                </a>
              </p>
            </div>
          )}
        </div>
      </section>

      {!isMobile && (
        <div style={styles.footerContainer}>
          <div style={styles.contactSection}>
            <h2 style={styles.contactTitle}>Text or Email Us!</h2>
            <div style={styles.contactInfo}>
              <a href="tel:+16504544583" style={styles.contactItem}>
                <span style={styles.icon}>📞</span>
                (650) 454-4583
              </a>
              <a href="mailto:brotdetailing@gmail.com" style={styles.contactItem}>
                <span style={styles.icon}>📧</span>
                brotdetailing@gmail.com
              </a>
            </div>
          </div>
          <p style={styles.footer}>&copy; 2025 BROT Auto Detailing</p>
        </div>
      )}
    </div>
  );
}

export default PackageDetail;
